// extracted by mini-css-extract-plugin
export default {"wrapper":"draggable_wrapper__ploGM"};